import { X } from 'lucide-react';
import { Button } from '@/shared/ui/button';
import { Card } from '@/shared/ui/card';

interface ImagePreviewProps {
  preview: string | null;
  onRemove: () => void;
  label?: string;
}

export function ImagePreview({ preview, onRemove, label }: ImagePreviewProps) {
  if (!preview) return null;

  return (
    <Card className="relative overflow-hidden bg-white/[0.03] border-white/[0.06]">
      <div className="relative aspect-video w-full">
        <img
          src={preview}
          alt={label || 'Preview'}
          className="w-full h-full object-cover"
        />
        <Button
          type="button"
          variant="destructive"
          size="icon"
          className="absolute top-2 right-2"
          onClick={onRemove}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      {label && (
        <div className="p-2 text-sm text-muted-foreground text-center">
          {label}
        </div>
      )}
    </Card>
  );
}
